// AI Tutor streaming presentation (doc 27, ST-01) -- pacing configuration.
//
// PROVISIONAL. Every number here is a starting value (doc 27 §8.1): derived
// from the Synova Widget's constants, the upstream's sentence-sized chunks and
// a simulation on real replies, NOT from a live arrival trace. ST-04
// calibrates them; nothing else in the presentation layer holds a pacing
// number, so this file is the only place ST-04 has to change.
//
// A "unit" is one reveal step: a word with its punctuation and the whitespace
// after it, or one atomic span (revealUnits.js).
export const REVEAL_PACING = Object.freeze({
  // natural pace, units per second (about 167 ms per word)
  baseUnitsPerSecond: 6,
  // while text is still arriving, the backlog is paced to drain in this time
  lagTargetSeconds: 2.0,
  // ceiling of the streaming pace
  maxUnitsPerSecond: 60,
  // once the text is complete, what is left is shown within this time ...
  flushSeconds: 1.5,
  // ... and never later than this, whatever its length
  hardBoundSeconds: 4.0,
  // a breath after a sentence or a paragraph, only when not catching up
  sentencePauseMs: 140,
  pauseMaxRateFactor: 1.5,
  // a frame longer than this (a stalled tab) counts as this
  maxFrameMs: 100,
  // the status gives way to the first word (TurnList / TurnBubble)
  handoffMs: 180,
})

// Reassurance under the status sentence, counted from the student's Send
// (doc 27 §28.2 D5).
export const THINKING_HINTS_MS = Object.freeze([12000, 25000, 45000])

/**
 * @param {Partial<typeof REVEAL_PACING>} [overrides]
 * @returns {typeof REVEAL_PACING}
 */
export function createRevealPacing(overrides) {
  return Object.freeze({ ...REVEAL_PACING, ...(overrides || {}) })
}
